import React from 'react';
import cn from 'classnames';

import {ModuleText} from '../Common';

import {IEditorialModule3} from './IEditorialModule3';

import styles from './EditorialModule3.module.scss';

const EditorialModule3 = ({body, title}: IEditorialModule3) => {
	return (
		<div className={cn(styles['module-editorial_module_3'], 'editorial_module_3')}>
			<ModuleText contentfulField="title" text={title} colorVariant="black" />
			{body}
		</div>
	);
};

export default EditorialModule3;
